import { isFeatureEnabled } from 'src/components/admin/home/featureGating';

/**
 * Filter grouped quick actions down to what the current user may see.
 *
 * An action is kept when:
 *   - it has no requiredRoles, or the user's userType is in requiredRoles; AND
 *   - its requiredFeature resolves enabled (see isFeatureEnabled).
 * Groups left with no visible actions are dropped entirely.
 *
 * Pure: no React, no context. `groups` is not mutated.
 *
 * @param {import('src/config/quickActions').QuickActionGroup[]} groups
 * @param {string} [userType]
 * @param {object} [systemFeatures]
 * @returns {import('src/config/quickActions').QuickActionGroup[]}
 */
export function filterQuickActionGroups(groups, userType, systemFeatures) {
  return (groups || [])
    .map((group) => ({
      ...group,
      actions: (group.actions || []).filter(
        (action) =>
          (!action.requiredRoles || action.requiredRoles.includes(userType)) &&
          isFeatureEnabled(action.requiredFeature, systemFeatures)
      )
    }))
    .filter((group) => group.actions.length > 0);
}
